<template>
  <div class="standardpage">
    <b-card>
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="pnrlibrary.icon" class="mr-1"></i>
            <span>{{ pnrlibrary.title }}</span></b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="issued_at" v-model="issued_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        issued_at = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Doc Number" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="docnumber" :debounce="pnrlibrary.debounce" placeholder="Doc Number"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!docnumber" @click="docnumber = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Locator" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="locator" :debounce="pnrlibrary.debounce" placeholder="Locator"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!locator" @click="locator = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Doc Date" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="docdate" :debounce="pnrlibrary.debounce" placeholder="Doc Date"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!docdate" @click="docdate = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="creationagentid" :debounce="pnrlibrary.debounce" placeholder="Agent"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!creationagentid"
                        @click="creationagentid = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="PCC" label-for="branch" label-cols="12">
                  <treeselect v-model="branch" :clearable="true" :multiple="true" :options="options_branch"
                    placeholder="Show all..."></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Locator ( Paste List )" label-for="reflist2" label-cols="12">

                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist2" v-model="locator" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Locator" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="locator = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Branch" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="branch" :debounce="pnrlibrary.debounce" placeholder="Branch"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!branch" @click="branch = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Source" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="source" :debounce="pnrlibrary.debounce" placeholder="Source"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!source" @click="source = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Booking Type" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="bookingtype" :debounce="pnrlibrary.debounce" placeholder="Booking Type"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!bookingtype"
                        @click="bookingtype = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Handoff Type" label-for="handofftype" label-cols="12">
                  <treeselect v-model="handofftype" :clearable="true" :multiple="true" :options="options_handofftype"
                    placeholder="Show all..."></treeselect>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Handoff Type" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="handofftype" :debounce="pnrlibrary.debounce" placeholder="Handoff Type"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!handofftype" @click="handofftype = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ticket No (XPath)" label-size="sm" id="ticketno">
                  <b-input-group>
                    <b-form-input v-model="ticketno" :debounce="pnrlibrary.debounce" placeholder="Ticket No (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ticketno" @click="ticketno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Passenger (XPath)" label-size="sm" id="passenger">
                  <b-input-group>
                    <b-form-input v-model="passenger" :debounce="pnrlibrary.debounce" placeholder="Passenger (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C (XPath)" label-size="sm" id="slac">
                  <b-input-group>
                    <b-form-input v-model="slac" :debounce="pnrlibrary.debounce" placeholder="Client SL A/C (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!slac" @click="slac = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Remark (XPath)" label-size="sm" id="remark">
                  <b-input-group>
                    <b-form-input v-model="remark" :debounce="pnrlibrary.debounce" placeholder="Remark (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!remark" @click="remark = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="HandOff Version (XPath)" label-size="sm" id="version">
                  <b-input-group>
                    <b-form-input v-model="version" :debounce="pnrlibrary.debounce" placeholder="HandOff Version (XPath)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!version" @click="version = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-tooltip target="ticketno" triggers="hover">
                Ticket No (XPath)
              </b-tooltip>
              <b-tooltip target="passenger" triggers="hover">
                Passenger (XPath)
              </b-tooltip>
              <b-tooltip target="version" triggers="hover">
                HandOff Version (XPath)
              </b-tooltip>
            </b-row>
          </b-card-body>
        </b-card>
        <!-- <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                    class="gridtoolbar"
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in pnrlibrary.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :pnrlibrary="tool.pnrlibrary"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div> -->
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="pnrlibrary" :icon="pnrlibrary.icon"
            :toolbarlibrary="pnrlibrary.toolbarlibrary" :tools="pnrlibrary.tools" :badges="pnrlibrary.badges"
            :fields="pnrlibrary.fields" :items="pnrlibrary.items" :busy="pnrlibrary.busy" :offset="pnrlibrary.offset"
            :limit="pnrlibrary.limit" :page="pnrlibrary.page" :showpages="true" @load="pnrlibrary_load"
            :downloaded="pnrlibrary.downloaded" @click="pnrlibrary_click" @select="pnrlibrary_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="pnrlibrary.selected" :config="cconfig"
          @discard="pnrlibrary_click('discard')"></component>
      </div>

      <!-- pnrlibrary_load {{ pnrlibrary.offset }} {{ pnrlibrary.limit }} {{ pnrlibrary.page }}<br />
      pnrlibrary_selected {{ pnrlibrary.selected.length }}
      {{ pnrlibrary.selectall }} -->
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import PNRView from "./Components/PNRView";
import PNRXml from "./Components/PNRXml";
import PNREdit from "./Components/PNREdit";
import PNRData from "./Components/PNRData";
import PNRAudit from "./Components/PNRAudit";

export default {
  name: "PNR",
  components: {
    PNRView,
    PNRXml,
    PNREdit,
    PNRData,
    PNRAudit,
  },
  watch: {
    async issued_at() {
      await this.pnrlibrary_load(0);
    },
    async locator() {
      if (this.locator.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        await this.pnrlibrary_load(0);
      } else {
        this.issued_at = { startDate: this.$moment().startOf("month").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
    },
    async branch() {
      await this.pnrlibrary_load(0);
    },
    async docnumber() {
      await this.pnrlibrary_load(0);
    },
    async creationagentid() {
      await this.pnrlibrary_load(0);
    },
    async docdate() {
      await this.pnrlibrary_load(0);
    },
    async source() {
      await this.pnrlibrary_load(0);
    },
    async bookingtype() {
      await this.pnrlibrary_load(0);
    },
    async handofftype() {
      await this.pnrlibrary_load(0);
    },
    async ticketno() {
      await this.pnrlibrary_load(0);
    },
    async passenger() {
      await this.pnrlibrary_load(0);
    },
    async slac() {
      await this.pnrlibrary_load(0);
    },
    async remark() {
      await this.pnrlibrary_load(0);
    },
    async version() {
      await this.pnrlibrary_load(0);
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {

        let state = this.pnrlibrary;

        // HIDE COLUMNS BELOW WIDTH
        if (newVal < 1500) {
          // state.fields[11].class = "d-none"
          // state.fields[12].class = "d-none"
        } else {
          // state.fields[11].class = "text-center"
          // state.fields[12].class = "text-center"
        }
        if (newVal < 1500) {
          state.fields[4].class = "d-none"
          state.fields[5].class = "d-none"
          state.fields[6].class = "d-none"
          state.fields[7].class = "d-none"

        } else {
          state.fields[4].class = "text-center"
          state.fields[5].class = "text-center"
          state.fields[6].class = "text-center"
          state.fields[7].class = "text-center"
        }
      },
    },
  },
  data() {
    return {
      busy: false,
      id: null,
      issued_at: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      status: null,
      branch: [],
      docnumber: null,
      creationagentid: null,
      docdate: null,
      fileref: null,
      source: null,
      bookingtype: null,
      handofftype: [],
      locator: [],
      creationdate: null,
      data: null,
      ticketno: null,
      passenger: null,
      slac: null,
      remark: null,
      version: null,
      message: null,
      tickets_at: this.$moment().format("YYYY-MM-DD"),
      status: null,
      options_branch: [
        // // AMR1
        // { id: "17TK", label: "17TK | AMR" },
        // // FOP2
        // { id: "8GHJ", label: "8GHJ | FOM" },
        // // MBM1
        // { id: "36GI", label: "36GI | MERCEDES" },
        // { id: "00XJ", label: "00XJ | MONSPRT" },
        // // MP4
        // { id: "4T5I", label: "4T5I | MCLAREN" },
        // { id: "3MRK", label: "3MRK | PIRELLI" },
        // // REN11
        // { id: "36RI", label: "36RI | ALPINE" },
        // { id: "4P1I", label: "4P1I | TP" },
        // { id: "18IK", label: "18IK | TPTEST" },
        // // WIL1
        // { id: "36NI", label: "36NI | WILLIAMS" },
        // { id: "Q3RL", label: "Q3RL | FORTESCUE" },
      ],
      options_handofftype: [
        { id: "CAR", label: "CAR" },
        { id: "HTL", label: "HTL" },
        { id: "HHT", label: "HHT" },
        { id: "LCC", label: "LCC" },
        { id: "LCO", label: "LCO" },
        { id: "FLT", label: "FLT" },
        { id: "TKT", label: "TKT" },
        { id: "EMD", label: "EMD" },
        { id: "RAL", label: "RAL" },
      ],
      pnrlibrary: {
        title: "PNR Library",
        icon: "fa fa-book text-primary",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        selectall: false,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-wrench text-danger",
            position: "toolbar",
            action: "audit",
            label: "PNR Audit",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-location-arrow text-primary",
            position: "toolbar",
            action: "lowcost",
            label: "Lowcost",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-car text-primary",
            position: "toolbar",
            action: "cars",
            label: "Cars",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-bed text-primary",
            position: "toolbar",
            action: "hotels",
            label: "Hotels",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-ticket text-primary",
            position: "toolbar",
            action: "ticket",
            label: "Tickets",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-gbp pr-1",
            position: "toolbar",
            action: "cost",
            label: "Cost",
            component: {
              name: "PNRView",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-table pr-1",
            position: "toolbar",
            action: "data",
            label: "Data",
            component: {
              name: "PNRData",
            },
          },
        ],
        tools: "go,download,clipboard,filter,edit,deleteconfirm,audit,lowcost,cars,hotels,ticket,data,xml,view",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "dateissued",
            label: "Date Issued",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
          },
          {
            key: "docnumber",
            label: "Doc Number",
            sortable: true,
          },
          {
            key: "docdate",
            label: "Doc Date",
            sortable: true,
            class: "text-center",
          },
          {
            key: "source",
            label: "Source",
            sortable: true,
            class: "text-center",
          },
          {
            key: "bookingtype",
            label: "Booking Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "handofftype",
            label: "Handoff Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "creationagentid",
            label: "Agent ID",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "branch",
            label: "PCC",
            sortable: true,
          },
          {
            key: "version",
            label: "Version",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "tickets_at",
            label: "Date Tickets",
            sortable: true,
            class: "text-center",
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "text-center",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-80px",
          },
        ],
        badges: [
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "status",
            type: "badge",
            Ready: "primary",
            Pending: "warning",
            Unticketed: "purple",
          },
        ],
        items: [],
        selected: [],
        denied: [],
        downloaded: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();

    let data = await this.$helpers.getsystemsetting("pnr_pcc");
    if (data) {
      this.options_branch = JSON.parse(data);
    }
  },
  async activated() {
    await this.pnrlibrary_load();
  },
  async deactivated() {
    // console.log('PNR deactivated')
  },
  methods: {
    accessdenied() {
      this.pnrlibrary.denied = [];
      if (!this.user.permissions.includes("pnrlibrary.delete")) {
        console.log("delete not found");
        this.pnrlibrary.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("pnrlibrary.save")) {
        console.log("save not found");
        this.pnrlibrary.denied.push("save");
      }
    },
    async load() {

    },
    async pnrlibrary_load(offset, limit, page) {

      let state = this.pnrlibrary;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        locator: this.locator.length > 0 ? this.locator.join(",") : null,
        branch: this.branch.length > 0 ? this.branch.join(",") : null,
        docnumber: this.docnumber,
        dateissued: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        creationagentid: this.creationagentid,
        docdate: this.docdate,
        source: this.source,
        bookingtype: this.bookingtype,
        handofftype: this.handofftype.length > 0 ? this.handofftype.join(",") : null,
        ticketno: this.ticketno,
        passenger: this.passenger,
        slac: this.slac,
        remark: this.remark,
        version: this.version,
        dateformat: "DD/MM/YYYY HH:MM:SS",
        orderby: [["issued_at", "desc"]],
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query pnrs(
              $limit: Int
              $offset: Int
              $id: String
              $branch: String
              $docnumber: String
              $creationagentid: String
              $docdate: String
              $fileref: String
              $source: String
              $bookingtype: String
              $handofftype: String
              $locator: String
              $creationdate: String
              $dateissued: [String]
              $ticketno: String
              $passenger: String
              $slac: String
              $remark: String
              $version: String
              $dateformat: String
              $orderby: [[String]]
            ) {
              pnrs(
                limit: $limit
                offset: $offset
                id: $id
                branch: $branch
                docnumber: $docnumber
                creationagentid: $creationagentid
                docdate: $docdate
                fileref: $fileref
                source: $source
                bookingtype: $bookingtype
                handofftype: $handofftype
                locator: $locator
                creationdate: $creationdate
                dateissued: $dateissued
                ticketno: $ticketno
                passenger: $passenger
                slac: $slac
                remark: $remark
                version: $version
                dateformat: $dateformat
                orderby: $orderby
              ) {
                id
                dateissued
                branch
                docnumber
                creationagentid
                docdate
                fileref
                source
                bookingtype
                handofftype
                locator
                creationdate
                version
                rows
                tickets_at
                status
                # data not needed for grid (and big)
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.pnrs
        } else {
          state.items = response.data.pnrs;
        }


        // if (limit == 0) {
        //   state.selected = this.cleanit(response.data.pnrs);
        // } else {
        //   state.items = response.data.pnrs;
        // }

        this.$store.dispatch("pnrs")

      } catch (error) {
        console.log(error);
      }
      state.busy = false;
    },

    async pnrload() {
      this.busyaction = true;
      let variables = {
        // limit: 9,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation loadPNRs($limit: Int) {
              loadPNRs(limit: $limit)
            }
          `,
          variables,
        });
        this.message =
          "<span class='text-primary'>" +
          response.data.loadPNRs.split("\n").join("<br/>") +
          "</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.$store.dispatch("pnrs")

      this.busyaction = false;
    },
    async pnrlibrary_click(a, ss) {
      console.log("pnrlibrary_click", a, ss);

      let state = this.pnrlibrary;
      if (state.selectall) {
        ss = state.selected
      }

      switch (a) {
        case "selectall":
          state.selectall = !state.selectall
          if (state.selectall) {
            await this.pnrlibrary_load(0, 0);
          } else {
            state.selected = []
          }
          break;

        case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.pnrlibrary_load(0, 0);
          break;


        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.pnrlibrary_load();
          break;

        case "add":
        case "edit":
          this.component = "PNREdit";
          break;

        case "view":
          this.component = "PNRView";
          break;
        case "data":
          this.component = "PNRData";
          break;
        case "audit":
          this.component = "PNRAudit";
          break;
        case "xml":
          this.component = "PNRXml";
          break;
        case "lowcost":
          this.lowcostit(ss);
          break;
        case "cars":
          this.carit(ss);
          break;
        case "hotels":
          this.hotelit(ss);
          break;
        case "ticket":
          this.ticketit(ss);
          break;
        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async pnrlibrary_select(ss, tools) {
      console.log("pnrlibrary_select", ss);

      let state = this.pnrlibrary;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "add",
          "download",
          "audit",
          "clipboard"
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "view", "xml", "data"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "cars", "hotels", "lowcost", "ticket"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });
        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },
    async fileit(files) {
      console.log("PNR.fileit:", files);

      let updated = 0;
      let variables = {
        files,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation pnrs_save($files: [FileUpload_input]) {
              pnrs_save(files: $files) {
                id
              }
            }
          `,
          variables,
        });
        if (response.data.pnrs_save.length > 0) {
          updated = response.data.pnrs_save.length;
          this.cconfig.find((o) => o.key == "message").value =
            "<span class='text-primary'>" +
            updated +
            " file(s) were uploaded to the database" +
            "</span>";
        }
      } catch (error) {
        console.log(error);
        this.cconfig.find((o) => o.key == "message").value =
          "<span class='text-danger'>" + error.message + "</span>";
      }
    },

    async lowcostit(ss) {

      let state = this.pnrlibrary;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        if (v.handofftype.includes('LCC') || v.handofftype.includes('LCO')) {
          rows.push({ id: v.id });
        }
      });

      let variables = {
        selected: rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation lowcost_unpack($selected: [PNR_input]) {
              lowcost_unpack(selected: $selected) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.load();
    },

    async carit(ss) {

      let state = this.pnrlibrary;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        if (v.handofftype.includes('CAR')) {
          rows.push({ id: v.id });
        }
      });

      let variables = {
        selected: rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation cars_unpack($selected: [PNR_input]) {
              cars_unpack(selected: $selected) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.load();
    },

    async hotelit(ss) {

      let state = this.pnrlibrary;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        if (v.handofftype.includes('HTL')) {
          rows.push({ id: v.id });
        }
      });

      let variables = {
        selected: rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation hotels_unpack($selected: [PNR_input]) {
              hotels_unpack(selected: $selected) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.load();
    },

    async ticketit(ss) {

      let state = this.pnrlibrary;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        if (v.handofftype.includes('TKT') || v.handofftype.includes('EMD')) {
          rows.push({ id: v.id });
        }
      });

      let variables = {
        selected: rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_unpack($selected: [PNR_input]) {
              tickets_unpack(selected: $selected) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false
      await this.load();
    },
    async deleteit(ss) {
      console.log("deleteit", s);

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation pnrs_delete($rows: [PNR_input]) {
              pnrs_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.pnrlibrary_load();
    },
  },
};
</script>

<style></style>